/* this is here because of legacy blockly blocks.  All dropdowns have filter now. */
import DropDownWithFilter from './DropDown';
export default DropDownWithFilter;
